import { Component, OnInit } from '@angular/core';
import { MERZ_ROUTES } from './merz-routes';
import { LoginApiClientService } from 'projects/dnest-core-angular/src/public-api';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Device } from '@capacitor/device';
import { NavController, Platform } from '@ionic/angular';
import { UserDetailService } from './services/user-detail-service/user-detail.service';
import { GalleryDetailService } from './services/gallery-detail-service/gallery-detail.service';
import { register } from 'swiper/element/bundle';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { environment } from 'src/environments/environment';

register();
@Component({
  selector: 'merz-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  MERZ_ROUTES = MERZ_ROUTES;

  constructor(
    private loginApiClientService: LoginApiClientService,
    private router: Router,
    private translateService: TranslateService,
    private platform: Platform,
    private userDetailService: UserDetailService,
    private navController: NavController,
    private galleryDetailService: GalleryDetailService,
  ) {
    this.initializeLanguage();
  }

  ngOnInit() {
    if (Capacitor.isNativePlatform()) {
      this.initPushListeners();
    }
  }

  private initPushListeners() {
    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      const url: string = action.notification.data?.url;
      if (url) {
        this.navigateFromPush(url);
      }
    });
  }

  private navigateFromPush(url: string) {
    if (url.includes('/contenido/')) {
      const galleryId = url.split('/').pop();
      if (galleryId) {
        this.galleryDetailService.getGalleryContent(galleryId);
      }
    } else {
      const path = url.replace(environment.share_url, '');
      const [routePath, queryString] = path.split('?');
      if (queryString) {
        const queryParams: { [key: string]: string } = {};
        queryString.split('&').forEach(pair => {
          const [k, v] = pair.split('=');
          if (k) queryParams[decodeURIComponent(k)] = decodeURIComponent(v ?? '');
        });
        this.navController.navigateForward([routePath], { queryParams });
      } else {
        this.navController.navigateForward([path]);
      }
    }
  }

  private async initializeLanguage() {
    await this.platform.ready();

    Device.getLanguageCode().then((language) => {
      const availableLanguages = this.userDetailService.availableLanguages;

      const languageSelected =
        this.userDetailService.language || language.value;

      if (availableLanguages.includes(languageSelected)) {
        this.translateService.use(languageSelected);
      } else {
        this.translateService.use(this.translateService.getDefaultLang());
      }
    });
  }

  get showHeaderdesktop() {
    return this.loginApiClientService.isLoggedIn() && this.noOneOfThisRoutes();
  }

  get showFooter() {
    return !this.router.url.includes(MERZ_ROUTES.welcomeComplete);
  }

  /**
   * Retorna si true si la url actual no pertence a ninguna de las que no están permitidas
   */
  noOneOfThisRoutes() {
    const currentUrl = this.router.url;
    return ![
      MERZ_ROUTES.registerPasswordComplete,
      MERZ_ROUTES.registerOcupationComplete,
      MERZ_ROUTES.registerFunctionComplete,
      MERZ_ROUTES.registerStatementComplete,
      MERZ_ROUTES.registerSpecialtyComplete,
      MERZ_ROUTES.registerMasterComplete,
      MERZ_ROUTES.registerMasterEndateComplete,
      MERZ_ROUTES.registerWorkcenterComplete,
      MERZ_ROUTES.registerWorkcenterAddComplete,
      MERZ_ROUTES.completeProfileComplete,
      MERZ_ROUTES.pollComplete,
      MERZ_ROUTES.preferencesComplete,
      MERZ_ROUTES.registerPhoneConfirmComplete,
    ].includes(currentUrl);
  }
}
